const fetchWithTimeout = (url, options, timeout = 5000) =>
  Promise.race([
    fetch(url, options),
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('Request timed out')), timeout);
    }),
  ]);

export default fetchWithTimeout;
